import { Route, Switch } from "react-router-dom";
import BannerPromotionList from "./BannerPromotionList";
import AddEditBannerPromotion from "./AddEditBannerPromotion";

const App =({ match }) => (

    <Switch>
        <Route exact path={`${match.url}`} component={BannerPromotionList} />
        <Route path={`${match.url}/add-edit/:id?`} component={AddEditBannerPromotion} />
    </Switch>
)

export default App;